import { render, staticRenderFns } from "./seminarsListPanel.vue?vue&type=template&id=735cce99&"
import script from "./seminarsListPanel.vue?vue&type=script&lang=js&"
export * from "./seminarsListPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports